import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Nav, Footer } from './components/Layout';
import Home from './pages/Home';
import Construction from './pages/Construction';
import Agents from './pages/Agents';
import IndustriEst from './pages/IndustriEst';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App" data-v="20260211b">
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/industriest" element={<IndustriEst />} />
          <Route path="/products/industriest" element={<IndustriEst />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
// Cache bust 1770850642
